import { Dispatch } from 'redux';

import { resetCart } from 'src/state/cart/cart-slice';
import { setReachedStep } from 'src/state/order/order-slice';
import { OrderStep } from 'src/state/order/types';

export const resetStateForNewServiceLocationActionCreator = () => (dispatch: Dispatch) => {
  dispatch(resetCart());
  dispatch(setReachedStep(OrderStep.CHOOSE_SERVICE_LOCATION));
};
